export default __webpack_public_path__ + "static/media/suggestion.cf9295d9.webp";